import classNames from "classnames";
import { CompanySidePanel } from "components/SidePanel/Company/CompanySidePanel";
import React from "react";
import { getCityStateCountry } from "shared/utils/addressUtils";

interface VenueForMapProps {
  selected: boolean
  hovered: boolean
  venue: server.dto.VenueSmall
  onOpen: () => void
  onHover: (venue: server.dto.VenueSmall) => void
}

const venueCategoryMap = serverReference.venueCategories.map(c => ({
  [c.value]: c.text
})).reduce((acc, c) => ({ ...acc, ...c }), {});

export const VenueForMap = ({ selected, hovered, venue, onOpen, onHover }: VenueForMapProps) => {

  const classes = classNames("hoverable gray-100 planning-map-venue-item-content", {
    "planning-map-item-content-selected": selected,
    "planning-map-item-content-hovered": hovered && !selected,
  });

  return <CompanySidePanel
    type="venue"
    onOpen={onOpen}
    companyId={venue.venueId}
    trigger={<div className={classes}
      onMouseEnter={() => onHover(venue)}
      onMouseLeave={() => onHover(undefined)}>
      <div className="grow1 flex-column gap-mini">
        <div className="text-ellipsis subtitle-text-medium">{venue.name}</div>
        <div className="text-ellipsis body-text-regular s1_gray">{getCityStateCountry(venue.address)}</div>
        {venue.category !== "unknown" && <div className="text-ellipsis body-text-regular s1_gray">{venueCategoryMap[venue.category]}</div>}
      </div>
      {Boolean(venue.capacity) && <div className="s1_gray s1_cell_financialamount">{venue.capacity} PAX</div>}
    </div>}
  />
};
